import { useMemo } from 'react';
import { INotice } from 'store/features/application/types/notice';
import { DEFAULT_ERROR_MESSAGE } from 'common/constants';
import { useIntl } from 'react-intl';

const useMessage = (data: INotice | null) => {
  const { formatMessage } = useIntl();

  const message = useMemo(() => {
    if (data && data.translateId)
      return formatMessage({ id: data?.translateId });
    if (data && data.status === 429) {
      return formatMessage({ id: `responseStatus.${429}` });
    }
    if (data && data.text) return data.text;
    return DEFAULT_ERROR_MESSAGE;
  }, [formatMessage, data]);

  return message;
};

export default useMessage;
